import { render, staticRenderFns } from "./VehicleCategory.vue?vue&type=template&id=10ae3fc1&scoped=true&"
import script from "./VehicleCategory.vue?vue&type=script&lang=js&"
export * from "./VehicleCategory.vue?vue&type=script&lang=js&"
import style0 from "./VehicleCategory.vue?vue&type=style&index=0&id=10ae3fc1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ae3fc1",
  null
  
)

export default component.exports